import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input
} from '@angular/core';
import { LOCATION_TOKEN } from '@new/common/location';
import { EntityData } from '@new/common/utils/entity-data';
import { RemoteData } from '@new/common/utils/remote-data';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

@Component({
  selector: 'man-table-error',
  templateUrl: './table-error.component.html',
  styleUrls: ['./table-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule],
  host: {
    role: 'alert'
  }
})
export class TableErrorComponent {
  @Input() public request: EntityData<unknown> | RemoteData<unknown>; // the union is needed because admin table components still pass RemoteData while pool tables now pass EntityData

  constructor(
    private store: Store,
    @Inject(LOCATION_TOKEN) private location: Location
  ) {}

  public onRetry(): void {
    if ('actions' in this.request && this.request.actions?.retry) {
      const retryActions = Array.isArray(this.request.actions.retry)
        ? this.request.actions.retry
        : [this.request.actions.retry];

      this.store.dispatch(retryActions.map(action => new action()));

      return;
    }

    this.location.reload();
  }
}
